import http from "../utils/request.js";
import { defineStore } from "pinia";
export const useDataDictionaryStore = defineStore("dataDictionary", {
    state: () => {
        return {};
    },
    getters: {},
    actions: {
        getCateTreeList() {
            return http.get("/sunAdmin/dataDictionary/getCateTreeList");
        },
        getCateInnerDataList(cateId) {
            return http.get("/sunAdmin/dataDictionary/getCateInnerDataList/" + cateId);
        },
        edit(data) {
            return http.post("/sunAdmin/dataDictionary/edit", data);
        },
        delete(id) {
            return http.get("/sunAdmin/dataDictionary/delete/" + id);
        },
    },
});
